import Head from "next/head";
import * as React from "react";

const PageSEO: React.FC<{
	title: string;
	description: string;
	keywords: string;
}> = ({ title, description, keywords }) => {
	return (
		<Head>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="Keywords" content={keywords} />
		</Head>
	);
};

export default PageSEO;
